<template>
    <section class="section d-flex align-items-center height-view">
        <b-container>
            <b-row>
                <b-col class="text-center">
                    <h1 class="textured-container text-center"> {{ $t('page_404.erreur') }} </h1>
                    <h3 class="text-center mb-4"> {{ $t('page_404.texte') }} </h3>
                    <b-button :to="{ name:'home'}" variant="secondary"  >
                        {{ $t('page_404.action') }}
                    </b-button>
                </b-col>
            </b-row>
        </b-container>
    </section>
</template>
